import { api } from 'app/config/apiConfig';
import { DepositHistory } from '../model/types';

interface Params {
  depositId: string;
}

export const getDepositHistoryApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDepositHistory: build.query<DepositHistory[], Params>({
      query: ({ depositId }) => ({
        url: `/billing-documents/deposits/${depositId}/history`,
      }),
      providesTags: ['Deposit History'],
    }),
  }),
});

export const { useGetDepositHistoryQuery } = getDepositHistoryApi;
